import { Component, OnInit, ViewChild, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { PopupBarComponent } from 'src/app/core/components/basic/popup-bar/popup-bar.component';
import { IdCodeLabel } from 'src/app/core/models/IdCodeLabel';
import { AssociationMembreActiviteDto } from '../../models/association-membre-activite-dto';
import { AssociationActiviteMembresComponent } from '../association-activite-membres/association-activite-membres.component';

@Component({
  selector: 'app-association-activite-membres-popup',
  templateUrl: './association-activite-membres-popup.component.html',
  styleUrls: ['./association-activite-membres-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AssociationActiviteMembresPopupComponent implements OnInit {
  @ViewChild(PopupBarComponent) popupBar: PopupBarComponent;
  /** Menu « Autres actions », ouvert par le bouton de l'en-tête de la fiche (#1083). */
  @ViewChild('menu', { static: true }) menu: TemplateRef<unknown>;
  // Volet F_MENU remplacé par le menu ci-dessus (#1083).
  // F_MENU = 'menu';
  F_NOUVEAU_MEMBRE = 'nouveauMembre';
  F_NOUVELLE_ACTIVITE = 'nouvelleActivite';

  constructor(
    public aamc: AssociationActiviteMembresComponent,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  // reset() {
  //   this.popupBar.reset(this.F_MENU, {});
  // }

  saisieEvenement() {
    this.router.navigate(['/evenement/create'], { queryParams: { participants: [this.aamc.membreAssocieList] } });
  }

  saisieMembre() {
    this.popupBar.reset(this.F_NOUVEAU_MEMBRE, {});
  }

  saisieActivite() {
    this.popupBar.reset(this.F_NOUVELLE_ACTIVITE, {});
  }

  onCreateMembre(id: number) {
    if (this.aamc.activiteMembres.filter((v) => !v.membre?.id).length) {
      // on met à jour la ligne sans membre renseigné
      const i = this.aamc.activiteMembres.findIndex((v) => !v.membre?.id);
      this.aamc.activiteMembres[i].membre.id = id;
      this.aamc.form.get('activiteMembreList').setValue(this.aamc.activiteMembres);
    } else {
      // on crée une nouvelle ligne d'association membre/activité
      this.aamc.activiteMembres.push(new AssociationMembreActiviteDto({ membre: new IdCodeLabel({ id: id }) }));
    }
    this.aamc.form.get('activiteMembreList').setValue(this.aamc.activiteMembres);
    this.popupBar.reset('', {});
  }

  onCreateActivite(id: number) {
    this.aamc.activiteSearchor.searchById(id).then(() => {
      this.aamc.form.reset({ id: id, miseEnSommeilSage: false });
      this.aamc.activiteId = id;
      this.aamc.activiteSearchor.initSearchParam();
    });
    this.popupBar.reset('', {});
  }
}
